import serviceBase from "../serviceProject";

const billingPeriodCostCentre = {
  ...serviceBase,

  preList: function(params) {
    return `projects/${params.project_id || "-"}/billing-periods/${
      params.billing_period_id
    }`;
  },

  preListOption: {
    getList: true,
    get: true,
    create: false,
    update: true,
    delete: false,
    deleteList: false
  },

  resource: "cost-centres"
};

export default billingPeriodCostCentre;
